import { DEFAULT_CURRENCY_DECIMAL_SEPARATOR } from '@utils/currency';
import { formatStringAsNumber } from '@utils/numbers';

const DEFAULT_RESULT = 0.00;

export const currencyParser = (decimalSeparator: string = DEFAULT_CURRENCY_DECIMAL_SEPARATOR) => (
  (value?: string): number => {
    if (value === undefined || value === null || value === '') return DEFAULT_RESULT;
    const number = Number(formatStringAsNumber(
      value
        .toString()
        .replace(decimalSeparator, DEFAULT_CURRENCY_DECIMAL_SEPARATOR)
    ));

    return Number.isNaN(number) ? DEFAULT_RESULT : number;
  }
);
